/** 账户相关的常量 */

// 账户类型
export const ACCOUNT_TYPE = {
  IB: 'ib', // 环球账户
  OMNIBUS: 'bs', // 标准账户
  VIRTUAL: 'virtual', // 虚拟账户
  ND: 'nd' // ND 账户
}

// 清算类型
export const CLEARING_TYPE = {
  IB: 'ib', // 第三方 IB 清算
  MARSCO: 'marsco' // 自研 Marsco 清算
}

// 资金账户类型
export const ASSET_ACCOUNT_TYPE = {
  CASH: 'CASH', // 现金账户
  MARGIN: 'MARGIN' // 保证金账户
}

// 开户状态
export const ACCOUNT_OPEN_STATUS = {
  UNACCOUNT: 'UNACCOUNT', // 未开户
  CONTINUE: 'CONTINUE', // 开户中
  INVALID: 'INVALID', // 无效账户
  AUDITING: 'AUDITING', // 审核中
  CLOSED: 'CLOSED', // 已关闭
  ACTIVATING: 'ACTIVATING', // 正在激活
  OPENED: 'OPENED', // 开户
  FUNDED: 'FUNDED' // 入金
}

// 期权答题状态
export const OPT_STATUS = {
  UNANSWERED: 1, // 未答题
  UNSIGNED: 2, // 未签协议
  SIGNED: 3 // 已签协议
}

// 港股行情权限类型
export const HK_QUOTE_TYPE = {
  UNAVAILABLE: 'unavailable', // 不可用
  BUY: 'buy', // 购买的权限
  COUPON: 'coupon' // 优惠券获取的权限
}

// 两步验证状态
export const TWO_STEP_VERIFY_STATUS = {
  OPENED: 1, // 已开通
  UNOPENED: 0 // 未开通
}

// 资金等级
export const ASSET_LEVEL = {
  OTHER: 0, // 其他账户
  LIMIT: 1, // 受限 < 2000
  NO_LIMIT: 2 // 不受限 >=2000
}

// 美国模拟账号 template_id
export const VIRTUAL_TEMPLATE_ID = 10000

// 模拟账户初始资产（小于初始值可以重置资产）
export const VIRTUAL_INITIAL_ASSET = 100000
